import React from "react";
import { Helmet } from "react-helmet-async";

function TermsAndConditions() {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Terms and Conditions | 237Mechanic</title>
        <meta name="description" content="Read the terms and conditions of using 237Mechanic's services. Learn about your rights, responsibilities, and service agreements." />
      </Helmet>

      <h1 className="text-3xl font-bold text-center mb-6">Terms and Conditions</h1>
      <p className="text-gray-600 text-center mb-8">
        Welcome to 237Mechanic! Please read these terms carefully before using our services.
      </p>

      <div className="space-y-6">
        {/* 1. Introduction */}
        <section>
          <h2 className="text-xl font-semibold">1. Introduction</h2>
          <p className="text-gray-700">
            These Terms and Conditions govern your use of 237Mechanic.com and the services we offer, including vehicle repair, servicing, and consultations.
          </p>
        </section>

        {/* 2. Services Offered */}
        <section>
          <h2 className="text-xl font-semibold">2. Services Offered</h2>
          <p className="text-gray-700">
            We provide vehicle repair, maintenance, spare parts sourcing, and importation consultations. All services are subject to availability.
          </p>
        </section>

        {/* 3. User Responsibilities */}
        <section>
          <h2 className="text-xl font-semibold">3. User Responsibilities</h2>
          <ul className="list-disc list-inside text-gray-700">
            <li>You must provide accurate vehicle details for proper servicing.</li>
            <li>Service fees must be paid before or upon service completion.</li>
            <li>You agree not to misuse or attempt to disrupt our platform.</li>
          </ul>
        </section>

        {/* 4. Payment and Refunds */}
        <section>
          <h2 className="text-xl font-semibold">4. Payment and Refunds</h2>
          <p className="text-gray-700">
            Payments can be made via Mobile Money, credit card, or other accepted methods. Refunds are only issued for services not rendered due to our fault.
          </p>
        </section>

        {/* 5. Warranty and Liability */}
        <section>
          <h2 className="text-xl font-semibold">5. Warranty and Liability</h2>
          <p className="text-gray-700">
            We provide a limited warranty on repairs, but we are not liable for damage caused by third-party interference or improper use of your vehicle.
          </p>
        </section>

        {/* 6. Dispute Resolution */}
        <section>
          <h2 className="text-xl font-semibold">6. Dispute Resolution</h2>
          <p className="text-gray-700">
            Any disputes should be reported to our support team. If unresolved, disputes will be settled under Cameroonian law.
          </p>
        </section>

        {/* 7. Changes to Terms */}
        <section>
          <h2 className="text-xl font-semibold">7. Changes to Terms</h2>
          <p className="text-gray-700">
            We reserve the right to update these terms at any time. Continued use of our services means you accept the updated terms.
          </p>
        </section>

        {/* 8. Contact Information */}
        <section>
          <h2 className="text-xl font-semibold">8. Contact Us</h2>
          <p className="text-gray-700">
            If you have any questions, please contact us at <a href="mailto:support@237mechanic.com" className="text-blue-600">support@237mechanic.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
}

export default TermsAndConditions;
